import React from "react";
import Header from "./Header";
import Particles from "./Particles";

const Home = () => {
  return (
    <React.Fragment>
      <Header />
      <Particles />
    </React.Fragment>
  );
};

export default Home;
